import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import useForecastRoutes from 'app/SkyNetRoutes/hooks/useForecastRoutes'
import requests from 'app/requests/Forecast/Forecast.requests'
import tableConfig from './ShortTermForecasts.config'
import ShortTermForecastOverview from './ShortTermForecastOverview'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const ShortTermForecasts = () => {
    const {
        ShortTermForecast: ShortTermForecastRoutes,
    } = useForecastRoutes()

    const tabs: SidebarTab[] = useTabsByPermission([{
        tab: {
            label: 'Overview',
            url: ShortTermForecastRoutes.Overview.route,
            Component: ShortTermForecastOverview,
        },
        permission: true,
    }])

    return (
        <SkyNetDomain
            name={tableConfig.name}
            sidebarTabs={tabs}
            defaultTab="overview"
            getDomainObject={requests.get}
            domainRequestKey={RequestKeys.getForecastById}
        >
            <SkyNetTable
                customUrl={requests.filterRequest().url}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default ShortTermForecasts
